//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'dayjs'
import uParse from '@/components/gaoyia-parse/parse.vue'
export default {
	data() {
		return {
			list: [],
			avgPrice: '',
			introduction: '',
			orderCode: ''
		}
	},
	components: {
		uParse
	},
	onLoad(event) {
		this.orderCode = event.orderCode
		this.queryData()
	},
	methods: {
		formatTime(item) {
			if (item === null || item === '') {
				return ''
			} else {
				return moment(item).format('MM月DD日')
			}
		},
		queryData() {
			this.$ajax({
				method: 'post',
				url: '/weChat/personalCenter/order/hotelOrderDetail',
				data: {
					orderCode: this.orderCode
				}
			}).then(res => {
				this.avgPrice = res.data.avgPrice
				this.list = res.data.dayPriceVoList
				this.introduction = res.data.reservationInstructions
			})
		}
	}
}
